import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BONUS_URL = `${API}/bonus/steuer-sparpaket-2027.pdf`;

export const submitEntry = (payload) => axios.post(`${API}/entries`, payload);

export const trackEvent = (event, location = "") =>
  axios.post(`${API}/analytics`, { event, location }).catch(() => {});

const detectDevice = () => {
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
};

const detectBrowser = () => {
  const ua = navigator.userAgent || "";
  if (/CriOS|Chrome/i.test(ua)) return "chrome";
  if (/Safari/i.test(ua)) return "safari";
  if (/Firefox|FxiOS/i.test(ua)) return "firefox";
  return "other";
};

// Keine Feldinhalte senden – nur grober Fehlerkontext
export const trackFormError = (code) =>
  axios.post(`${API}/form-errors`, {
    code,
    browser: detectBrowser(),
    device: detectDevice(),
  }).catch(() => {});

export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password });

export const adminStats = (token) =>
  axios.get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } });

export const adminEntries = (token, params = {}) =>
  axios.get(`${API}/admin/entries`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });

export const adminFormErrors = (token) =>
  axios.get(`${API}/admin/form-errors`, { headers: { Authorization: `Bearer ${token}` } });

export const adminDraws = (token) =>
  axios.get(`${API}/admin/draws`, { headers: { Authorization: `Bearer ${token}` } });

export const adminExecuteDraw = (token, drawDate) =>
  axios.post(`${API}/admin/draws/execute`, { draw_date: drawDate }, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const adminSetWinnerStatus = (token, drawDate, entryId, status) =>
  axios.patch(`${API}/admin/draws/${drawDate}/winners/${encodeURIComponent(entryId)}`, { status }, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const downloadCsv = async (token, kind = "all") => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  };
  let url = `${API}/admin/entries.csv`;
  let filename = "chickenwinner-teilnahmen.csv";
  if (kind === "partner") {
    url = `${API}/admin/entries.csv?marketing=1`;
    filename = "chickenwinner-partner-leads.csv";
  } else if (kind === "draws") {
    url = `${API}/admin/draws.csv`;
    filename = "chickenwinner-ziehungen.csv";
  }
  const res = await axios.get(url, config);
  const blobUrl = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(blobUrl);
};
